// extracted by mini-css-extract-plugin
export var chip = "_5c-0";
export var filterDropdown = "_5c-5";
export var filterItem = "_5c-6";
export var icon = "_5c-1";
export var removeButton = "_5c-3";
export var removeIcon = "_5c-4";
export var separator = "_5c-2";